import { all } from "redux-saga/effects"
import create from "./create"
import read from "./read"
import update from "./update"
import remove from "./remove"

export default function*() {
  while (true) {
    yield all({
      create: create(),
      read: read(),
      update: update(),
      remove: remove(),
    })
  }
}
